import type {
  TGrupoIntermediarias,
  TGrupoMensais,
  TGrupoParcela,
  TGrupoParcelas,
} from '@/utils/calculadora-valores-totais/processador-valores-decimal'

export type TDataParcela = string | null | undefined

export type TExtratorDeDatas<T> = (grupos: T) => TDataParcela[]

export const extraiDatasEntradas =
  <T extends { entradas?: TGrupoParcelas }>(): TExtratorDeDatas<T> =>
  (g) =>
    g.entradas?.map((e) => e.data) ?? []

export const extraiDatasIntermediarias =
  <T extends { intermediarias?: TGrupoIntermediarias[] }>(): TExtratorDeDatas<T> =>
  (g) =>
    g.intermediarias?.flatMap((i) => i.parcelas.map((p) => p.data)) ?? []

export const extraiDatasMensais =
  <T extends { mensais?: TGrupoMensais[] }>(): TExtratorDeDatas<T> =>
  (g) =>
    g.mensais?.map((m) => m.dataFim) ?? []

export const extraiDataSaldo =
  <T extends { saldo?: TGrupoParcela | null }>(): TExtratorDeDatas<T> =>
  (g) =>
    g.saldo?.valor ? [g.saldo.data] : []

export const extraiDataPosConclusao =
  <T extends { posConclusao?: TGrupoMensais }>(): TExtratorDeDatas<T> =>
  (g) =>
    g.posConclusao?.dataFim ? [g.posConclusao.dataFim] : []
